import { DomainName } from "@/sites/domains";

export const getGTMId = (siteDomain: string) => {
  switch (siteDomain) {
    case DomainName.QRCreator:
      return process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID_QRCREATOR;
    case DomainName.FastQRGenerator:
      return process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID_FASTQRGENERATOR;
    case DomainName.OnlineQRCode:
      return process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID_ONLINEQRCODE;
    case DomainName.QRNow:
      return process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID_QRNOW;
    default:
      return process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID_QRCREATOR;
  }
};
